/**
 * Typed chat on Vercel. The prefix already tells the model the Norwegian line.
 * It still answered «Farzad Bayats kunstige intelligens» (preview a920ec3c).
 * A bare nb identity ask gets the agreed line here, before the model runs.
 */

export const NB_IDENTITY_LINE = 'Jeg er F.B/c, Farzads KI-assistent.'

export const NB_HOW_LINE =
  'Jeg er F.B/c, Farzads KI-assistent. Det tekniske er mindre viktig enn hvordan jeg kan hjelpe dere.'

const NB_HOW = /^hvordan fungerer du[?.!\s]*$/i

const NB_WHO =
  /^(?:(?:hvem|hva) er du|hva slags (?:ki|ai) er du|er du (?:gemini|google|en ki|en ai))[?.!\s]*$/i

/** The agreed Norwegian line, or null when this turn is not a bare identity ask. */
export function deterministicNbIdentityReply(userText: string | null | undefined): string | null {
  const text = (userText ?? '').trim()
  if (!text) return null
  if (NB_HOW.test(text)) return NB_HOW_LINE
  if (NB_WHO.test(text)) return NB_IDENTITY_LINE
  return null
}

/**
 * A model reply to that ask must say KI, not AI. «kunstige intelligens» is replaced
 * with the agreed line. A reply that already says KI-assistent and has no AI word stays.
 */
export function enforceNbIdentityReply(userText: string | null | undefined, reply: string): string {
  const fixed = deterministicNbIdentityReply(userText)
  if (!fixed) return reply
  if (
    reply.includes('KI-assistent') &&
    !/kunstig/i.test(reply) &&
    !/\bAI\b/.test(reply)
  ) {
    return reply
  }
  return fixed
}
